import AuthService from './AuthService';
import ApiService from "./ApiService";

class ContractsService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._tableDataUrl = '/profile/contracts/list';
        this._tableHeaderUrl = '/profile/contracts/table-data';
        this._createContractUrl = '/profile/contracts/create';
        this._removeContractUrl = '/profile/contracts/delete';
        this._downloadContractUrl = '/profile/contracts/download';
        this._attachContractUrl = '/profile/contracts/attach-to-order';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    attachToOrder(params) {
        return this.postResource(this._attachContractUrl, params, this.getBaseHeaders())
    }
    createContract(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._createContractUrl, data, headers)
    }
    download(params) {
        return this.getResource(this._downloadContractUrl, params, this.getBaseHeaders())
    }
    remove(params) {
        return this.postResource(this._removeContractUrl, params, this.getBaseHeaders())
    }
    getTableData() {
        return this.postResource(this._tableDataUrl, {}, this.getBaseHeaders())
    }
    getTableHeaderData() {
        return this.postResource(this._tableHeaderUrl, {}, this.getBaseHeaders())
    }
}

const service = new ContractsService(AuthService);

export default service;
